import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import rootReducer from "./reducers";
import { initializeAuthAction } from "./actions/authActions";

const createAppStore = async () => {
  try {
    const store = configureStore({
      reducer: rootReducer,
      middleware: [thunk],
    });

    // Wait for the auth check to resolve before handing the store back —
    // otherwise the app renders one frame with userData still null and
    // briefly flashes the sign-in page even when a valid token exists.
    await store.dispatch(initializeAuthAction());

    return store;
  } catch (err) {
    throw new Error("Some error occurred");
  }
};

export default createAppStore;